import { profileApi, userApi } from '@/api'
import Cookies from 'js-cookie'
import cookies from '@/cookies'

export class UserPermissionChecker {
  public static async check(permission: string): Promise<boolean> {
    try {
      const { hasPermission } = await userApi.checkPermission(permission)

      return hasPermission
    } catch {
      return false
    }
  }

  public static async isUserAuthenticated(): Promise<boolean> {
    try {
      let currentUser = await userApi.getCurrent()

      return !!currentUser
    } catch {
      return false
    }
  }

  public static async isUserAdmin(): Promise<boolean> {
    let isUserAdminCookie = Cookies.get(cookies.IS_USER_ADMIN)

    if (!isUserAdminCookie) {
      return this.check('ROLE_ADMIN')
    }

    return isUserAdminCookie === 'true'
  }

  public static async isPasswordResetTokenValid(token: string): Promise<boolean> {
    try {
      await profileApi.isPasswordResetTokenValid(token)
    } catch {
      return false
    }

    return true
  }
}
